<template>
    <div class=card >
        <div class="card-header bg-transparent">
            <div class="row">
                <div class="col-md-8 text-cente text-md-left">
                    <strong v-if="type == 1" >
                        Contas a Pagar
                    </strong>
                    <strong v-else >
                        Contas Pagas
                    </strong>
                </div>
                <div class="col-md-4 text-cente text-md-right">
                    <div class="btn-group" role="group" aria-label="Basic example">
                        <button
                            type="button" @click.prevent="type = 1" 
                            class="btn btn-sm"
                            v-bind:class="[type == 1 ? 'btn-primary' : 'btn-secondary', 'btn-primary']"
                        >
                            Em aberto
                        </button>
                        <button 
                            type="button" @click.prevent="type = 2"
                            class="btn btn-sm"
                            v-bind:class="[type == 2 ? 'btn-primary' : 'btn-secondary', 'btn-primary']"
                        >
                            Pagas
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row" v-if="type == 1" >
                <div class="col-xl-2 col-sm-6 mb-3 col-6">
                    <div class="card text-white bg-primary o-hidden h-100">
                        <div class="card-body">
                            <div class="">
                                <small> {{bills.DP_QTD_REG_HJ}} Hoje</small>
                                <br />
                                <strong>{{formater(bills.DP_TOTAL_HJ)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-sm-6 mb-3 col-6">
                    <div class="card text-white bg-primary o-hidden h-100">
                        <div class="card-body">
                            <div class="">
                                <small>{{bills.DP_QTD_REG_SEMANA}} Na Semana</small>
                                <br />
                                <strong>{{formater(bills.DP_TOTAL_SEMANA)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-sm-6 mb-3 col-6">
                    <div class="card text-white bg-primary o-hidden h-100">
                        <div class="card-body">
                            <div class="">
                                <small>{{bills.DP_QTD_REG_MES}} No mês</small>
                                <br />
                                <strong>{{formater(bills.DP_TOTAL_MES)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-sm-6 mb-3 col-6">
                    <div class="card text-white bg-primary o-hidden h-100">
                        <div class="card-body">
                            <div class="">
                                <small>{{bills.DP_QTD_REG_ANO}} No Ano</small>
                                <br />
                                <strong>{{formater(bills.DP_TOTAL_ANO)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-sm-12 mb-3 col-12">
                    <div class="card text-white bg-primary o-hidden h-100">
                        <div class="card-body">
                            <div class="">
                                <small>{{bills.DP_QTD_REG_INADIMPLENTES}} Inadimplencia(s)</small>
                                <br />
                                <strong>{{formater(bills.DP_TOTAL_INADIMPLENTES)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>

                <div class="col-xl-2 col-sm-6 mb-3 col-6">
                    <div class="card text-white bg-info o-hidden h-100">
                        <div class="card-body">
                            <div class="">
                                <small> {{bills.CONTAS_DP_HOJE}} Hoje</small>
                                <br />
                                <strong>{{formater(bills.CONTAS_DP_TOTAL_HOJE)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-sm-6 mb-3 col-6">
                    <div class="card text-white bg-info o-hidden h-100">
                        <div class="card-body">
                            <div class="">
                                <small>{{bills.CONTAS_DP_SEMANA}} Na Semana</small>
                                <br />
                                <strong>{{formater(bills.CONTAS_DP_TOTAL_SEMANA)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-sm-6 mb-3 col-6">
                    <div class="card text-white bg-info o-hidden h-100">
                        <div class="card-body">
                            <div class="">
                                <small>{{bills.CONTAS_DP_MES}} No mês</small>
                                <br />
                                <strong>{{formater(bills.CONTAS_DP_TOTAL_MES)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-sm-6 mb-3 col-6">
                    <div class="card text-white bg-info o-hidden h-100">
                        <div class="card-body">
                            <div class="">
                                <small>{{bills.CONTAS_DP_ANO}} No Ano</small>
                                <br />
                                <strong>{{formater(bills.CONTAS_DP_TOTAL_ANO)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-sm-12 mb-3 col-12">
                    <div class="card text-white bg-info o-hidden h-100">
                        <div class="card-body">
                            <div class="">
                                <small>{{bills.COUNT_INAD_DP}} Inadimplencia(s)</small>
                                <br />
                                <strong>{{formater(bills.CONTAS_DP_TOTAL_INAD)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'cardListBillsToPay',
        data(){
            return{
                type: 1,
                bills: {
                    COUNT_INAD_DP: 0,
                    CONTAS_DP_HOJE: 0,
                    CONTAS_DP_SEMANA: 0,
                    CONTAS_DP_MES: 0,
                    CONTAS_DP_ANO: 0,
                    CONTAS_DP_TOTAL_INAD: 0,
                    CONTAS_DP_TOTAL_HOJE: 0,
                    CONTAS_DP_TOTAL_SEMANA: 0,
                    CONTAS_DP_TOTAL_MES: 0,
                    CONTAS_DP_TOTAL_ANO: 0,
                    DP_QTD_REG_INADIMPLENTES: 0,
                    DP_QTD_REG_HJ: 0,
                    DP_QTD_REG_SEMANA: 0,
                    DP_QTD_REG_MES: 0,
                    DP_QTD_REG_ANO: 0,
                    DP_TOTAL_INADIMPLENTES: 0,
                    DP_TOTAL_HJ: 0,
                    DP_TOTAL_SEMANA: 0,
                    DP_TOTAL_MES: 0,
                    DP_TOTAL_ANO: 0
                },

				interval		: 0
            }
		},
		computed: {
			getToken(){
				return this.$store.getters.getToken
			}
		},
		methods: {
			getData: function(){
				fetch(server + 'listas/contas/pagar', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
					.then(response => (response.json()) )
					.then(responseJSON => {
                        if(responseJSON.data == true){
                            this.bills  = responseJSON.response[0]
                        }else{
                            this.bills = {
                                COUNT_INAD_DP: 0,
                                CONTAS_DP_HOJE: 0,
                                CONTAS_DP_SEMANA: 0,
                                CONTAS_DP_MES: 0,
                                CONTAS_DP_ANO: 0,
                                CONTAS_DP_TOTAL_INAD: 0,
                                CONTAS_DP_TOTAL_HOJE: 0,
                                CONTAS_DP_TOTAL_SEMANA: 0,
                                CONTAS_DP_TOTAL_MES: 0,
                                CONTAS_DP_TOTAL_ANO: 0,
                                DP_QTD_REG_INADIMPLENTES: 0,
                                DP_QTD_REG_HJ: 0,
                                DP_QTD_REG_SEMANA: 0,
                                DP_QTD_REG_MES: 0,
                                DP_QTD_REG_ANO: 0,
                                DP_TOTAL_INADIMPLENTES: 0,
                                DP_TOTAL_HJ: 0,
                                DP_TOTAL_SEMANA: 0,
                                DP_TOTAL_MES: 0,
                                DP_TOTAL_ANO: 0
                            }
                        }

					})
					.catch(() => {
                            this.bills = {
                                COUNT_INAD_DP: 0,
                                CONTAS_DP_HOJE: 0,
                                CONTAS_DP_SEMANA: 0,
                                CONTAS_DP_MES: 0,
                                CONTAS_DP_ANO: 0,
                                CONTAS_DP_TOTAL_INAD: 0,
                                CONTAS_DP_TOTAL_HOJE: 0,
                                CONTAS_DP_TOTAL_SEMANA: 0,
                                CONTAS_DP_TOTAL_MES: 0,
                                CONTAS_DP_TOTAL_ANO: 0,
                                DP_QTD_REG_INADIMPLENTES: 0,
                                DP_QTD_REG_HJ: 0,
                                DP_QTD_REG_SEMANA: 0,
                                DP_QTD_REG_MES: 0,
                                DP_QTD_REG_ANO: 0,
                                DP_TOTAL_INADIMPLENTES: 0,
                                DP_TOTAL_HJ: 0,
                                DP_TOTAL_SEMANA: 0,
                                DP_TOTAL_MES: 0,
                                DP_TOTAL_ANO: 0 
                            }
					})
			},
			syncData: function(){
				this.interval = setInterval(() => {
					this.getData()
				}, 30000)
            },
            
            formater: function(value){
                const formatter = new Intl.NumberFormat('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2
                })

                return formatter.format(value)
            }
		},
		mounted(){
			this.getData()
		},
		created(){
			
        },
        beforeRouterEnter(to, from, next){
            this.syncData()
        },
        beforeRouterLeave(to, from, next){
            clearInterval(this.interval)
        }
	}
</script>

<style scoped>
    .col-6 .card-body{
        /* padding: 0.2rem 0; */
    }
</style>
